module.exports = __webpack_public_path__ + "img/Pot2.b21c39f5.svg";